<app-content-area
  [title]="'MY_DATA.TITLE' | translate"
  (emitterEventActionClick)="handleContentAreaEvent($event)"
>
  <app-form-area
    (emitterEventActionClick)="handleFormAreaEvent($event)"
  >
    <h4> {{ 'PEOPLE_FORM.FORM.PEOPLE_DATA.TITLE' | translate }}</h4>
    <app-input
      type="text"
      [label]="'PEOPLE_FORM.FORM.PEOPLE_DATA.NAME' | translate"
      [placeholder]="'PEOPLE_FORM.FORM.PEOPLE_DATA.NAME_PLACEHOLDER' | translate"
      [control]="form.get('nameCorporate')"
    />
    <app-input
      type="text"
      [label]="'PEOPLE_FORM.FORM.PEOPLE_DATA.NICKNAME' | translate"
      [placeholder]="'PEOPLE_FORM.FORM.PEOPLE_DATA.NICKNAME_PLACEHOLDER' | translate"
      [control]="form.get('tradeName')"
    />
    <app-input
      type="text"
      [label]="'PEOPLE_FORM.FORM.PEOPLE_DATA.CPF' | translate"
      [placeholder]="'PEOPLE_FORM.FORM.PEOPLE_DATA.CPF_PLACEHOLDER' | translate"
      [control]="form.get('document')"
      mask="cpf"
      (valueChange)="handleDocumentChange($event)"
    />
    <app-select
      label="{{ 'PEOPLE_FORM.FORM.ICMS_TAXPAYER.TITLE' | translate }}"
      placeholder="{{ 'PEOPLE_FORM.FORM.ICMS_TAXPAYER.PLACEHOLDER' | translate }}"
      [control]="form.get('icmsTaxpayer')"
      [items]="icmsTaxpayerOptions"
      (valueChange)="handleIcmsTaxpayerChange()"
    />
    <app-input
      type="text"
      [label]="stateRegistrationLabel | translate"
      [placeholder]="stateRegistrationPlaceholder | translate"
      [control]="form.get('stateRegistrationId')"
      [mask]="stateRegistrationMask"
    />
    <app-input
      type="text"
      [label]="'PEOPLE_FORM.FORM.PEOPLE_DATA.MUNICIPAL_REGISTRATION' | translate"
      [placeholder]="'PEOPLE_FORM.FORM.PEOPLE_DATA.MUNICIPAL_REGISTRATION_PLACEHOLDER' | translate"
      [control]="form.get('municipalRegistration')"
    />
    <app-select
      label="{{ 'PEOPLE_FORM.FORM.ENTERPRISE_TYPE.TITLE' | translate }}"
      placeholder="{{ 'PEOPLE_FORM.FORM.ENTERPRISE_TYPE.PLACEHOLDER' | translate }}"
      [control]="form.get('enterpriseType')"
      [items]="enterpriseTypeOptions"
      search
    />
    <div class="slide-toggle-container">
      <mat-slide-toggle
        labelPosition="before"
        [checked]="form.get('status')?.value === true"
        (change)="form.get('status')?.setValue($event.checked)"
        color="primary"
      >
        {{ 'PEOPLE_FORM.FORM.PEOPLE_DATA.STATUS' | translate }}
      </mat-slide-toggle>
    </div>
    <app-card-area
      [title]="'PEOPLE_FORM.FORM.CONTACTS.TITLE' | translate"
      (emitterEvent)="addContacts()"
      [buttonLabel]="'PEOPLE_FORM.FORM.CONTACTS.ADD_BUTTON' | translate"
    >
      @for (contactsCtrl of telephoneContacts.controls; track $index) {
        <app-contacts-card
          [control]="contactsCtrl"
          [index]="$index"
          (remove)="removeContacts($index)"
          [totalItems]="telephoneContacts.length"
        />
      }
    </app-card-area>
    <app-card-area
      [title]="'PEOPLE_FORM.FORM.EMAIL.TITLE' | translate"
      (emitterEvent)="addEmail()"
      [buttonLabel]="'PEOPLE_FORM.FORM.EMAIL.ADD_BUTTON' | translate"
    >
    @for (emailCtrl of emails.controls; track $index) {
      <app-email-card
        [control]="emailCtrl"
        [index]="$index"
        (remove)="removeEmail($index)"
        [totalItems]="emails.length"
        [disabled]="
          emailCtrl.get('isMain')?.value &&
          emailCtrl.get('initialValue')?.value
        "
      />
    }
    </app-card-area>
    <app-card-area
      [title]="'PEOPLE_FORM.FORM.FINANCIAL_INFORMATION.TITLE' | translate"
      (emitterEvent)="addPaymentMethods()"
      [buttonLabel]="'PEOPLE_FORM.FORM.FINANCIAL_INFORMATION.ADD_BUTTON' | translate"
    >
      @for (paymentMethodsCtrl of paymentMethods.controls; track $index) {
        <app-financial-information-card
          [control]="paymentMethodsCtrl"
          [index]="$index"
          (remove)="removePaymentMethods($index)"
          [totalItems]="paymentMethods.length"
        />
      }
    </app-card-area>
    <app-input
      type="text"
      [label]="'PEOPLE_FORM.FORM.PEOPLE_DATA.CREDIT_LIMIT' | translate"
      [placeholder]="'PEOPLE_FORM.FORM.PEOPLE_DATA.CREDIT_LIMIT_PLACEHOLDER' | translate"
      [control]="form.get('creditLimit')"
      mask="currency"
    />
    <h4> {{'PEOPLE_FORM.FORM.FISCAL_ENCLOSURE.TITLE' | translate}} </h4>
    <app-select
      label="{{ 'PEOPLE_FORM.FORM.FISCAL_ENCLOSURE.TITLE' | translate }}"
      placeholder="{{ 'PEOPLE_FORM.FORM.FISCAL_ENCLOSURE.PLACEHOLDER' | translate }}"
      [control]="form.get('taxFramework')"
      [items]="fiscalEnclosureOptions"
      search
    />
    <app-card-area
      [title]="'PEOPLE_FORM.FORM.ADDRESSES.TITLE' | translate"
      (emitterEvent)="addAddress()"
      [buttonLabel]="'PEOPLE_FORM.FORM.ADDRESSES.ADD_BUTTON' | translate"
    >
      @for (addressCtrl of addresses.controls; track $index) {
        <app-address-card
          [control]="addressCtrl"
          [index]="$index"
          (remove)="removeAddress($index)"
          [totalItems]="addresses.length"
        />
      }
    </app-card-area>
    <h4> {{'MY_DATA.FORM.S3_TITLE' | translate}} </h4>
    <app-document-upload
      [id]="form.get('digitalCertificate')?.value"
      [label]="'MY_DATA.FORM.S3_TITLE' | translate"
      [control]="form.get('digitalCertificate')"
      type="DigitalCertificate"
    />
    @if(id) {
      <app-input
        type="password"
        [label]="'PEOPLE_FORM.FORM.PEOPLE_DATA.PASSWORD' | translate"
        [placeholder]="'PEOPLE_FORM.FORM.PEOPLE_DATA.PASSWORD_PLACEHOLDER' | translate"
        [control]="form.get('certificatePassword')"
      />
    }
    @else {
      <app-input
        type="text"
        [label]="'PEOPLE_FORM.FORM.PEOPLE_DATA.PASSWORD' | translate"
        [placeholder]="'PEOPLE_FORM.FORM.PEOPLE_DATA.PASSWORD_PLACEHOLDER' | translate"
        [control]="form.get('certificatePassword')"
      />
    }
  </app-form-area>
</app-content-area>
